import { render, staticRenderFns } from "./RendGenericDateTime.vue?vue&type=template&id=13324f5e&"
import script from "./RendGenericDateTime.vue?vue&type=script&lang=js&"
export * from "./RendGenericDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports